import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { compose } from 'redux';
import theme from '../../styles/theme';

const Empty = ({
  classes,
  title,
  description,
}) => (
  <div className={classes.container}>
    <div className={classes.hero}>
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M41.6667 27C49.7668 27 56.3333 33.5665 56.3333 41.6667C56.3333 49.7669 49.7668 56.3334 41.6667 56.3334C33.5665 56.3334 27 49.7669 27 41.6667C27 33.5665 33.5665 27 41.6667 27ZM41.6667 47.6693C40.7469 47.6693 40.0013 48.4149 40.0013 49.3347C40.0013 50.2544 40.7469 51 41.6667 51C42.5864 51 43.332 50.2544 43.332 49.3347C43.332 48.4149 42.5864 47.6693 41.6667 47.6693ZM41.6668 31.9976C38.8722 31.9976 36.6953 34.1773 36.7244 37.209C36.7315 37.9453 37.3342 38.5365 38.0705 38.5295C38.8069 38.5224 39.398 37.9197 39.391 37.1834C39.3762 35.6394 40.3501 34.6642 41.6668 34.6642C42.9264 34.6642 43.9425 35.7093 43.9425 37.1962C43.9425 37.7089 43.795 38.109 43.3454 38.6936L43.0947 39.0026L42.8307 39.3046L42.123 40.0782L41.7591 40.4972C40.7369 41.7153 40.3334 42.6106 40.3334 43.9909C40.3334 44.7273 40.9304 45.3242 41.6668 45.3242C42.4032 45.3242 43.0001 44.7273 43.0001 43.9909C43.0001 43.449 43.1561 43.0336 43.637 42.4169L43.8634 42.1393L44.1326 41.8314L44.8413 41.0567L45.2003 40.6432C46.209 39.4409 46.6092 38.5546 46.6092 37.1962C46.6092 34.253 44.4162 31.9976 41.6668 31.9976ZM27.0594 32.3315C26.2682 33.567 25.6294 34.9095 25.1696 36.3324L6.33978 36.3332C5.23686 36.3332 4.34277 37.2273 4.34277 38.3302V39.8706C4.34277 41.2991 4.8524 42.6807 5.78002 43.7669C9.12218 47.6808 14.3645 49.6696 21.6667 49.6696C23.2572 49.6696 24.7502 49.5752 26.1473 49.3871C26.8011 50.7068 27.6213 51.9297 28.578 53.0307C26.4567 53.458 24.1503 53.6696 21.6667 53.6696C13.2777 53.6696 6.91499 51.2558 2.73819 46.3645C1.19216 44.554 0.342773 42.2514 0.342773 39.8706V38.3302C0.342773 35.0181 3.02772 32.3332 6.33978 32.3332L27.0594 32.3315ZM21.6667 0.345703C29.0305 0.345703 35 6.31524 35 13.679C35 21.0428 29.0305 27.0124 21.6667 27.0124C14.3029 27.0124 8.33333 21.0428 8.33333 13.679C8.33333 6.31524 14.3029 0.345703 21.6667 0.345703ZM21.6667 4.3457C16.512 4.3457 12.3333 8.52438 12.3333 13.679C12.3333 18.8337 16.512 23.0124 21.6667 23.0124C26.8213 23.0124 31 18.8337 31 13.679C31 8.52438 26.8213 4.3457 21.6667 4.3457Z" fill="#DFDFDF" />
      </svg>
    </div>

    <div className={classes.title}>
      { title }
    </div>

    <div className={classes.description}>
      { description }
    </div>
  </div>
);

Empty.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default compose(
  injectSheet({
    container: {
      marginTop: 96,
      marginBottom: 96,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#696969',
    },
    hero: {
      marginBottom: 8,
    },
    title: {
      marginBottom: 4,
      fontSize: 16,
      fontWeight: theme.fonts.boldWeight,
    },
    description: {
      textAlign: 'center',
      font: theme.fonts.body,
      maxWidth: 400,
      fontWeight: 400,
      fontSize: 14,
    },
  }),
)(Empty);
